import { useContext, useEffect, useState } from "react";
import { getModelDetails } from "../../../../services/restAPI/FormsV3";
import { FormBuilderFormItem } from "../FormBuilderTypes";
import { FormField } from "../../../../services/restAPI/FormV3Types";
import { FormBuilderContext } from "../FormBuilderContext";
import { highlight, updateViewOptionsDecorator } from "../utils";
import { useTokenInput } from "../../../../Hooks/useTokenInput";

interface NonPrimitiveFieldInterface {
   item: FormBuilderFormItem | FormField;
}

const NonPrimitiveField: React.FC<NonPrimitiveFieldInterface> = ({ item }) => {
   const [additionalFields, setAdditionalFields] = useState<FormField[]>([]);
   const { updateItem, listItems } = useContext(FormBuilderContext);

   const { inputValue, clickedFields, setInputValue, handleCursor, handleKeyDown } = useTokenInput({
      value:
         listItems
            //@ts-ignore
            .find((i) => i.uuid === item.uuid)
            ?.decorators?.find((d) => d.name === "ViewOptionsDecorator")?.properties?.fieldsView ||
         "",
      onChange: (val) => {
         //@ts-ignore
         updateItem(item.uuid, (old) => updateViewOptionsDecorator(old, val));
      },
   });

   const updateClickedFields = (field: string) => {
      const exists = clickedFields.includes(field);
      let newVal = inputValue;

      if (!exists) {
         newVal += (newVal.endsWith(" ") || newVal.length === 0 ? "" : " ") + `{${field}} `;
      }
      setInputValue(newVal);
   };

   function isFormField(item: FormBuilderFormItem | FormField): item is FormField {
      return (item as FormField).modelField !== undefined;
   }

   useEffect(() => {
      if (isFormField(item)) {
         if (!item.modelField.type.isPrimitive) {
            getModelDetails(item.modelField.type.module, item.modelField.type.name).then((res) =>
               setAdditionalFields(res?.data || []),
            );
         } else {
            setAdditionalFields([]);
         }
      } else {
         const [module, model] = item.type?.split(".") || [];
         if (module && model && module !== "primitives") {
            getModelDetails(module, model).then((res) => setAdditionalFields(res?.data || []));
         } else {
            setAdditionalFields([]);
         }
      }
   }, [item]);

   return (
      <div style={{ width: "16rem" }}>
         <div style={{ marginBottom: "8px" }}>
            {additionalFields
               ?.filter((field) => !clickedFields.includes(field.name))
               ?.map(
                  (field) =>
                     field?.isPrimitive && (
                        <button
                           key={field.name}
                           className={`${clickedFields.includes(field.name) ? "button-active list-builder-query-button" : "list-builder-query-button"}`}
                           onClick={() => updateClickedFields(field.name)}
                        >
                           {field.name}
                        </button>
                     ),
               )}
         </div>

         <div className="npf-container">
            <div
               className="highlight-layer"
               dangerouslySetInnerHTML={{ __html: highlight(inputValue || "") }}
            />

            <textarea
               className="npf-textarea"
               spellCheck="false"
               value={inputValue}
               onChange={(e) => setInputValue(e.target.value)}
               onClick={handleCursor}
               onKeyUp={handleCursor}
               onKeyDown={handleKeyDown}
            />
         </div>
      </div>
   );
};

export default NonPrimitiveField;
